export default "__VITE_ASSET__B8d3ATkL__"